import React, { useEffect } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import KycFailWrapper from "./KycFail.style";
import Header from "../../../../_shared/Header/header";
import NewKyc from "../../../../_shared/Failure/NewKyc";
import { useSelector } from "react-redux";

const KycFail = () => {

  return (
    <>
      <NewKyc />
    </>
  );
};

export default withTranslation()(KycFail);   